var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitCard6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 39,
    height: 39,
    fill: "#E2DEFF",
    stroke: "#4A03A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1199 25.9395L30.4399 26.5895C30.5999 26.9095 31.0099 27.2095 31.3499 27.2695L31.7799 27.3395C33.0899 27.5595 33.3899 28.5195 32.4599 29.4595L32.0599 29.8595C31.7899 30.1295 31.6499 30.6495 31.7299 31.0295L31.7799 31.2695C32.1399 32.8495 31.2999 33.4595 29.9299 32.6295L29.6399 32.4495C29.2899 32.2395 28.7099 32.2395 28.3599 32.4495L28.0699 32.6295C26.6899 33.4595 25.8599 32.8495 26.2199 31.2695L26.2699 31.0295C26.3499 30.6595 26.2099 30.1295 25.9399 29.8595L25.5399 29.4595C24.6099 28.5095 24.9099 27.5595 26.2199 27.3395L26.6499 27.2695C26.9999 27.2095 27.3999 26.9095 27.5599 26.5895L27.8799 25.9395C28.4999 24.6895 29.4999 24.6895 30.1199 25.9395Z",
    fill: "#4A03A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.19 13H18.81C15.17 13 13 15.17 13 18.81V27.19C13 30.83 15.17 33 18.81 33H24.09C24.44 33 24.69 32.64 24.65 32.29C24.61 31.91 24.63 31.46 24.75 30.94C24.77 30.87 24.75 30.79 24.69 30.73L24.47 30.51C23.62 29.65 23.31 28.61 23.61 27.66C23.92 26.72 24.78 26.06 25.97 25.86L26.27 25.81L26.54 25.27C27.09 24.15 27.99 23.5 29 23.5C30.01 23.5 30.91 24.15 31.46 25.27L31.61 25.58C31.68 25.73 31.82 25.83 31.98 25.86C32.07 25.88 32.16 25.9 32.25 25.92C32.6 26.01 33 25.73 33 25.36V18.81C33 15.17 30.83 13 27.19 13ZM27.26 19.96L24.95 22.94C24.66 23.31 24.25 23.55 23.78 23.6C23.32 23.66 22.85 23.53 22.49 23.24L20.66 21.82C20.59 21.76 20.51 21.76 20.47 21.77C20.43 21.77 20.36 21.79 20.3 21.87L17.92 24.96C17.77 25.15 17.55 25.25 17.32 25.25C17.16 25.25 17 25.2 16.86 25.09C16.53 24.84 16.47 24.37 16.72 24.04L19.1 20.95C19.39 20.58 19.8 20.34 20.27 20.28C20.74 20.22 21.2 20.35 21.57 20.64L23.4 22.08C23.47 22.14 23.54 22.13 23.59 22.13C23.63 22.13 23.7 22.11 23.76 22.03L26.07 19.05C26.32 18.72 26.79 18.66 27.12 18.92C27.46 19.17 27.51 19.64 27.26 19.96Z",
    fill: "#4A03A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCard6);
export default __webpack_public_path__ + "static/media/benefit-card-6.5619d33b24b9182cf374a6bf2af66aa2.svg";
export { ForwardRef as ReactComponent };